import { Routes, Route } from 'react-router'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import RecettesByType from './pages/RecettesByType'
import DepensesByFunction from './pages/DepensesByFunction'
import DrillDown from './pages/DrillDown'
import ComparaisonsUE from './pages/ComparaisonsUE'
import Ask from './pages/Ask'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="recettes" element={<RecettesByType />} />
        <Route path="depenses" element={<DepensesByFunction />} />
        <Route path="detail/:type/:id" element={<DrillDown />} />
        <Route path="comparaisons" element={<ComparaisonsUE />} />
        <Route path="ask" element={<Ask />} />
      </Route>
    </Routes>
  )
}
